<form #bankForm="ngForm" novalidate>
  <inline-msg [inlineMsg]="componentMessage"></inline-msg>
  <div class="col-12 text-center" *ngIf="refreshing">
    <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
  </div>
  <div class="form-group row">
    <div class="col-6 bank-type">
      <label *ngIf="transfer" [ngClass]="{'active': bank?.transferMethod === enumTransferMethod.ACH}">
        <fa-icon [icon]="['far', (bank?.transferMethod !== enumTransferMethod.ACH) ? 'circle' : 'check-circle']"></fa-icon>
        <input type="radio" name="transferMethod" [value]="enumTransferMethod.ACH" [(ngModel)]="bank.transferMethod" (change)="selectTransferType()">ACH
      </label>
      <label *ngIf="transfer" [ngClass]="{'active': bank?.transferMethod === enumTransferMethod.IBAN}">
        <fa-icon [icon]="['far', (bank?.transferMethod !== enumTransferMethod.IBAN) ? 'circle' : 'check-circle']"></fa-icon>
        <input type="radio" name="transferMethod" [value]="enumTransferMethod.IBAN" [(ngModel)]="bank.transferMethod" (change)="selectTransferType()">IBAN
      </label>
      <h6 *ngIf="!transfer" i18n="@@BANKING-FORM-003">Check Information</h6>
    </div>
    <div class="col-6 text-right bank-mode-switch" (click)="transferOrCheck()">
      <span class="link" *ngIf="transfer" i18n="@@BANKING-FORM-004">Want to send a check?</span>
      <span class="link" *ngIf="!transfer" i18n="@@BANKING-FORM-005">Want to set up a transfer?</span>
    </div>
  </div>

  <div class="info-box" *ngIf="transfer">
    <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
    <p>In order to change your bank information please fill this form again.</p>
    <button type="button" class="btn notd-primary-btn" (click)="setNewBankInfo()">Set New Information</button>
  </div>

  <div class="bank-section" [hidden]="!transfer" [@enterAnimation] [ngClass]="{'active': transfer}">
    <div class="form-group row">
      <div class="col-12">
        <label for="bankNameId">
          Bank name
          <fa-icon [icon]="['far', 'check-circle']" *ngIf="bankForm?.controls?.bankName?.valid" class="validation-icon"></fa-icon>
          <fa-icon [icon]="['far', 'times-circle']" *ngIf="bankForm?.controls?.bankName?.errors?.required" class="validation-icon required"></fa-icon>
        </label>
        <input id="bankNameId" [disabled]="blockFields" type="text" trimText maxlength="100" class="form-control" required placeholder="Bank name" name="bankName" [(ngModel)]="bank.name" i18n-placeholder="@@BANKING-FORM-006"/>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
        <label for="acountHolderId">
          Account holder
          <fa-icon [icon]="['far', 'check-circle']" *ngIf="bankForm?.controls?.accountHolder?.valid" class="validation-icon"></fa-icon>
          <fa-icon [icon]="['far', 'times-circle']" *ngIf="bankForm?.controls?.accountHolder?.errors?.required" class="validation-icon required"></fa-icon>
        </label>
        <input id="acountHolderId" [disabled]="blockFields" type="text" trimText maxlength="100" class="form-control" required placeholder="Account holder" name="accountHolder" [(ngModel)]="bank.accountHolder" i18n-placeholder="@@BANKING-FORM-007"/>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
        <label for="acountNumberId">
          Account number
          <fa-icon [icon]="['far', 'check-circle']" *ngIf="!bankForm?.controls?.accountNumber?.errors?.required" class="validation-icon"></fa-icon>
          <fa-icon [icon]="['far', 'times-circle']" *ngIf="(bank.accNumLast4 && blockFields) ? false : bankForm?.controls?.accountNumber?.errors?.required" class="validation-icon required"></fa-icon>
        </label>
        <!--<a *ngIf="bank.accNumLast4"-->
           <!--class="change-account-link"-->
           <!--(click)="changeAccountNumber()" title="{{!editBankAccount ? 'Change account number' : 'Go back'}}">{{!editBankAccount ? 'Change account number' : 'Go back'}}</a>-->
        <input type="text"
               *ngIf="blockFields"
               [disabled]="true"
               [value]="(bank.accNumLast4) ? '****' + bank.accNumLast4 : ''"
               class="form-control"
               placeholder="Account number"
               name="accountNumber"/>
        <input id="acountNumberId"
               *ngIf="!blockFields"
               type="text"
               minlength="9"
               maxlength="100"
               trimText
               class="form-control"
               required
               placeholder="Account number"
               name="accountNumber"
               [(ngModel)]="bank.accountNumber" i18n-placeholder="@@BANKING-FORM-008"/>
      </div>
    </div>
    <div class="form-group row" *ngIf="bank.transferMethod === enumTransferMethod.ACH">
      <div class="col-12 col-sm-12">
        <label for="routingNumberId">
          Routing number
          <fa-icon [icon]="['far', 'check-circle']" *ngIf="bankForm?.controls?.routingNumber?.valid" class="validation-icon"></fa-icon>
          <fa-icon [icon]="['far', 'times-circle']" *ngIf="bankForm?.controls?.routingNumber?.errors?.required" class="validation-icon required"></fa-icon>
        </label>
        <input id="routingNumberId" [disabled]="blockFields" type="text" minlength="9" trimText trimTrail="true" maxlength="100" regExpValidator="^[0-9]{1,}$" class="form-control" required placeholder="Routing number" name="routingNumber" [(ngModel)]="bank.routingNumber" i18n-placeholder="@@BANKING-FORM-009"/>
        <div *ngIf="bankForm?.controls?.routingNumber?.errors?.regExpValidator?.format" class="notd-input-error" i18n="@@BANKING-FORM-010">It must be a number with at least 9 digits.</div>
        <div *ngIf="bankForm?.controls?.routingNumber?.errors?.trimValidator" class="notd-input-error" i18n="@@GLOBAL-WHITE-SPACES-FORBIDDEN">White spaces are not allowed.</div>
      </div>
    </div>
    <div class="form-group row">
      <div class="form-group col-12 col-sm-12 col-md-6 col-lg-6" *ngIf="bank?.transferMethod === enumTransferMethod.IBAN">
        <div>
          <label for="ibanId">
            IBAN
            <fa-icon [icon]="['far', 'check-circle']" *ngIf="bankForm?.controls?.iban?.valid" class="validation-icon"></fa-icon>
            <fa-icon [icon]="['far', 'times-circle']" *ngIf="bankForm?.controls?.iban?.errors?.required" class="validation-icon required"></fa-icon>
          </label>
          <input id="ibanId" [disabled]="blockFields" type="text" trimText ngxIban wordCounter = "1" maxlength="100" class="form-control" required placeholder="IBAN" name="iban" [(ngModel)]="bank.iban" i18-placeholdern="@@BANKING-FORM-011"/>
        </div>
        <div *ngIf="bankForm?.controls?.iban?.errors?.iban" class="notd-input-error" i18n="@@BANKING-FORM-012">Wrong iban.</div>
        <div *ngIf="bankForm?.controls?.iban?.errors?.wordValidator" class="notd-input-error" i18n="@@GLOBAL-WHITE-SPACES-FORBIDDEN">White spaces are not allowed.</div>
      </div>
      <div *ngIf="bank.transferMethod === enumTransferMethod.IBAN" class="form-group col-12 col-sm-12 col-md-6 col-lg-6">
        <div>
          <label for="swiftId">
            Swift
            <fa-icon [icon]="['far', 'check-circle']" *ngIf="bankForm?.controls?.swift?.valid" class="validation-icon"></fa-icon>
            <fa-icon [icon]="['far', 'times-circle']" *ngIf="bankForm?.controls?.swift?.errors?.required" class="validation-icon required"></fa-icon>
          </label>
          <input id="swiftId" [disabled]="blockFields" type="text" trimText regExpValidator="^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$" maxlength="100" class="form-control" required placeholder="Swift" name="swift" [(ngModel)]="bank.swift" i18n-placeholder="@@BANKING-FORM-013"/>
        </div>
        <div *ngIf="bankForm?.controls?.swift?.errors?.regExpValidator?.format" class="notd-input-error" i18n="@@BANKING-FORM-014">Wrong swift.</div>
      </div>
    </div>
  </div>
  <div class="bank-section"  *ngIf="!transfer" [@enterAnimation]  [ngClass] = "{'active': !transfer}">
    <p i18n="@@BANKING-FORM-015">We will send a check from a US bank account to the address you have listed above</p>
  </div>
  <inline-msg [inlineMsg]="componentMessage"></inline-msg>
</form>

